export enum StepStatsEnum {
  InProgress = "InProgress",
  Completed = "Completed",
  Planned = "Planned",
}

export interface StepProps {
  title: string;
  description: string;
  time: string;
  status: StepStatsEnum;
}

export interface StepItemProps extends StepProps {
  stepIndex: number;
  totalSteps: number;
  prevStep?: StepProps;
}
